import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PatientUploadPage } from './patient-upload';

@NgModule({
  declarations: [
    PatientUploadPage,
  ],
  imports: [
    IonicPageModule.forChild(PatientUploadPage),
  ],
})
export class PatientUploadPageModule {}



// WEBPACK FOOTER //
// ./src/pages/patient-upload/patient-upload.module.ts